module.exports = __webpack_public_path__ + "media/assets/images/flags/tc-ad73aa1d7d5e87ad928fa3bf51226d36.svg";